var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap_404"},[_c('img',{staticClass:"img_404",attrs:{"src":require("../../assets/imgs/404.png"),"alt":""}}),_c('h2',[_vm._v("抱歉，您访问的页面出错了")]),_c('h3',[_vm._v("该网页可能已删除或者不存在")]),_c('div',{staticClass:"index_btn"},[_c('router-link',{attrs:{"to":{name:'Search'}}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }